import { Layout } from "providers/Layout";
import { useNavigate } from "react-router-dom";
import {
  Button,
  ButtonSize,
  ButtonVariant,
  IconButton,
  Input
} from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { Card } from "shared/components/Card";
import { useSettingsController } from "views/settings-integration/controller";
import { Delete01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { DeleteHubSportIntegrationModal } from "./components/DeleteHubSportIntegrationModal";
import { useState } from "react";
import { deleteHubSpotIntegration } from "api/landlord/landlord";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";
import { useAuthContext } from "providers/Auth";

export const HubSpotView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();
  const [
    showDeleteHubSportIntegrationModal,
    setShowDeleteHubSportIntegrationModal
  ] = useState(false);
  const { hubspotHubId } = useSettingsController();

  const handleRemoveId = async () => {
    deleteHubSpotIntegration()
      .then(() => {
        toast.success("HubSpot integration deleted successfully");
        setShowDeleteHubSportIntegrationModal(false);
        navigate("/settings/integration");
        refreshPartnerData();
      })
      .catch((err) => {
        toast.error(getErrorMessage(err));
      });
  };

  return (
    <Layout
      header={
        <>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 md:px-6 pb-3">
            <BreadCrumbs
              crumbs={[
                { title: "Settings", href: "/settings" },
                { title: "Integration", href: "/settings/integration" },
                {
                  title: "HubSpot",
                  href: "/settings/integration/hubspot"
                }
              ]}
            />
          </div>
          <h1 className="text-xl font-bold text-content-1000 p-6 pb-3">
            HubSpot
          </h1>
        </>
      }
      footer={
        <div className="flex justify-end gap-2">
          <Button
            variant={ButtonVariant.BASE}
            size={ButtonSize.SM}
            onClick={() => navigate("/settings/integration")}
            className="w-[125px]"
          >
            Cancel
          </Button>
        </div>
      }
    >
      <Card className="w-full p-6 max-w-[800px]">
        <p className="font-bold">Credentials</p>

        <div className="mt-6 border-t border-alpha-10 pt-6 flex flex-col">
          <div className="flex gap-2 w-full mb-4">
            <Input
              value={hubspotHubId}
              readOnly
              id="hubspotId"
              placeholder="HubSpot ID"
              wrapperClassName="w-full"
            />
            <IconButton
              className="shrink-0"
              HugeIcon={Delete01Icon}
              onClick={() => setShowDeleteHubSportIntegrationModal(true)}
            />
          </div>
        </div>
      </Card>
      <DeleteHubSportIntegrationModal
        opened={showDeleteHubSportIntegrationModal}
        onClose={() => setShowDeleteHubSportIntegrationModal(false)}
        onDelete={handleRemoveId}
      />
    </Layout>
  );
};
